import { useEffect, useRef } from 'react';
import H from '@here/maps-api-for-javascript';
import withTranslation from 'hoc/withTranslation';
import { buildAreaPolygons } from './utils/areaPolygonFactory';
import { attachAreaEvents } from './utils/areaEvents';

const NewMapAreas = ({ map, areaPolygon, onClick, tourData, translations }) => {
  const groupRef = useRef(null);
  const tourDataRef = useRef(tourData);
  const onClickRef = useRef(onClick);

  useEffect(() => {
    tourDataRef.current = tourData;
  });

  useEffect(() => {
    onClickRef.current = onClick;
  });

  useEffect(() => {
    if (!map) return undefined;
    groupRef.current = new H.map.Group();
    map.addObject(groupRef.current);
    return () => {
      if (groupRef.current) {
        groupRef.current.removeAll();
        map.removeObject(groupRef.current);
        groupRef.current = null;
      }
    };
  }, [map]);

  useEffect(() => {
    if (!groupRef.current) return;
    groupRef.current.removeAll();
    if (!areaPolygon?.features?.length) return;

    const polygons = buildAreaPolygons(areaPolygon.features);
    polygons.forEach((polygon) =>
      attachAreaEvents(polygon, map, tourDataRef, translations, (properties) =>
        onClickRef.current?.(properties),
      ),
    );
    groupRef.current.addObjects(polygons);
  }, [map, areaPolygon]);

  return null;
};

export default withTranslation(NewMapAreas);
